// PDF React View
import { yupResolver } from "@hookform/resolvers/yup";
import UploadForm from "components/shared-components/UploadForm";
import { generateSelectField } from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  resetUploadAttackFileInvoice,
  uploadAttackFileInvoice,
  uploadCampaignsInvoice,
} from "store/issue-invoice/actions";
import * as yup from "yup";
import { SELECT_FILTER_TYPE } from "../helper/functionHelper";

const UploadFileAttack = props => {
  const { isOpen, toggle, importHandle, idRootInvoice } = props;
  const { addToast } = useToasts();

  const [listFile, setListFile] = useState([]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { buStoreHeader } = Dashboard;

  useEffect(() => {
    if (isOpen) {
      setListFile([]);
    }
  }, [isOpen]);

  const dispatch = useDispatch();
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { uploadFile, loadingUploadFile, type } = issueInvoice;

  // Action Dispatch
  useEffect(() => {
    if (uploadFile && uploadFile.success) {
      setListFile([...listFile, { id: uploadFile.id, file_name: "" }]);
      dispatch(resetUploadAttackFileInvoice());
    }
  }, [uploadFile]);

  const handleFiles = (files, uploadType = "") => {
    setListFile([]);
    if (files.length > 0) {
      for (const item of files) {
        const bodyFormData = new FormData();
        bodyFormData.append("file", item);
        dispatch(uploadAttackFileInvoice(bodyFormData, uploadType, true));
      }
    }
  };

  const schema = yup.object().shape({
    typeCampaign: yup
      .object()
      .required(1, "Vui lòng chọn loại hóa đơn")
      .nullable(),
  });

  const OPTION_TYPE = Object.entries(SELECT_FILTER_TYPE).map(([key, value]) => {
    return {
      value: key,
      label: value,
    };
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      typeCampaign: OPTION_TYPE[0],
    },
  });

  const submitForm = submitData => {
    const { typeCampaign } = submitData;
    dispatch(
      uploadCampaignsInvoice(typeCampaign.value, listFile[0].id, buStoreHeader)
    );
  };

  return (
    <Modal
      size="lg"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Upload file</Label>
        </ModalHeader>
        <ModalBody>
          {generateSelectField(
            "Loại hóa đơn",
            true,
            errors,
            "typeCampaign",
            "Vui lòng chọn",
            false,
            control,
            OPTION_TYPE,
            "auto",
            () => {
              //   dispatch(
              //     listKhddInvoiceToSummary(getValues("khmshdon").value)
              //   );
            },
            false,
            false,
            false,
            false
          )}
          <div className="mt-2"></div>
          <UploadForm
            multiple={false}
            handleFiles={files => handleFiles(files)}
            accept=".xlsx"
            removeFile={(a, index) => {
              listFile.splice(index, 1);
              setListFile(listFile);
            }}
          ></UploadForm>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={listFile.length === 0}
            onClick={handleSubmit(submitForm)}
          >
            <i className="bx bx-save label-icon" />
            Lưu file
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

UploadFileAttack.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  importHandle: PropTypes.any,
  idRootInvoice: PropTypes.any,
};

export default UploadFileAttack;
